import Vue from "vue";
import Router from "vue-router";
import { getSession, userInfo } from "../tools/config";
import Login from "../pages/login";

//巡店
import CruiseShop from "../pages/cruiseShop/index.vue";
import ShopStoretList from "../pages/cruiseShop/home.vue";
import ShopBasicInfo from "../pages/cruiseShop/basicInfo/index.vue";
import ShopCheckItems from "../pages/cruiseShop/checkItems/index.vue";
import ShopAssessment from "../pages/cruiseShop/assessment/index.vue";

//考勤
import Attendance from "../pages/attendance/index.vue";
import StoretList from "../pages/attendance/home.vue";
import EditScheduling from "../pages/attendance/editScheduling/index.vue";
import HistoryScheduling from "../pages/attendance/historyScheduling/index.vue";
import OvertimeRecords from "../pages/attendance/overtimeRecords/index.vue";
import ApproveInfo from "../pages/attendance/overtimeRecords/approveInfo/index.vue";
import ShiftApply from "../pages/attendance/shiftApply/index.vue";
import ShiftInfo from "../pages/attendance/shiftApply/shiftInfo/index.vue";
import VacationApply from "../pages/attendance/vacationApply/index.vue";
import VacationInfo from "../pages/attendance/vacationApply/vacationInfo/index.vue";
import RetroactiveApply from "../pages/attendance/retroactiveApply/index.vue";
import RetroactiveInfo from "../pages/attendance/retroactiveApply/retroactiveInfo/index.vue";

import AttendanceStatistics from "../pages/attendance/statistics/index.vue";
import HourStatistics from "../pages/attendance/hour/index.vue";
import OvertimeDetails from "../pages/attendance/overtimeDetails/index.vue";

//资料库
import Library from "../pages/database/home.vue";
import DatabaseIndex from "../pages/database/index.vue";

//门店
import Stores from "../pages/stores/home.vue";
import StoresIndex from "../pages/stores/index.vue";
import StoresInfoIndex from "../pages/stores/storesInfo/index.vue";
import StoresInfoIndexSecond from "../pages/stores/indexSecond.vue";
import Area from "../pages/stores/area.vue";
import AreaSecond from "../pages/stores/areaSecond.vue";
import City from "../pages/stores/city.vue";
import CitySecond from "../pages/stores/citySecond.vue";

//报表
import Report from "../pages/report/index.vue";
import WorkingHours from "../pages/report/workingHours/index.vue";
import ShopStatistics from "../pages/report/shopStatistics/index.vue";
import SalesStatistics from "../pages/report/salesStatistics/index.vue";

//服务工单
import ServiceWorkOrder from "../pages/serviceWorkOrder/index.vue";
import WorkOrderInfo from "../pages/serviceWorkOrder/info.vue";
import ServiceManage from "../pages/serviceWorkOrder/serviceManage/serviceManage.vue";

//系统
import System from "../pages/system/index";
import Region from "../pages/system/components/region";
import Dictionary from "../pages/system/components/diction";
import Roles from "../pages/system/components/limits";
import DataHome from "../pages/system/components/database/home";
import DataIndex from "../pages/system/components/database/index";
import Parameters from "../pages/system/components/systemParameter";
import Products from "../pages/system/components/productSku";
import Custom from "../pages/system/components/custom";
import TaskManagement from "../pages/system/components/taskManagement";
import companyNotice from "../pages/system/components/companyNotice";
import messageAuthentication from "../pages/system/components/messageAuthentication";
//日志
import logtab from "../pages/system/components/logtab.vue";
import log_tab1 from "../pages/system/components/log_tab1.vue";
import log_tab2 from "../pages/system/components/log_tab2.vue";

//开发
import Systemdevelop from "../pages/develop/index";
import Regiondevelop from "../pages/develop/components/region";
import Dictionarydevelop from "../pages/develop/components/diction";
import Rolesdevelop from "../pages/develop/components/limits";
import DataHomedevelop from "../pages/develop/components/database/home";
import DataIndexdevelop from "../pages/develop/components/database/index";
import Parametersdevelop from "../pages/develop/components/systemParameter";
import Productsdevelop from "../pages/develop/components/productSku";
import phonemenu from "../pages/develop/components/phonemenu";
import pcmenu from "../pages/develop/components/pcmenu";
import customDevelop from "../pages/develop/components/custom";
import developTaskManage from "../pages/develop/components/developTaskManage";
//服务
import Service from "../pages/service/home";
//辖区管理
import JurisdictionIndex from "../pages/jurisdiction/index";
import JurisdictionIndexTow from "../pages/jurisdiction/indexTow";
import Territory from "../pages/jurisdiction/home";
import Organization from "../pages/jurisdiction/region";
import Institutions from "../pages/jurisdiction/institutions";
import InstitutionsTow from "../pages/jurisdiction/institutionsTow";

// 销售数据管理常州
import changzhou from "../pages/changzhou/home";
import changzhou_set from "../pages/changzhou/changzhou_set";

import JurisdictionIndexActive from "../pages/jurisdiction/indexactive";
import JurisdictionIndexActiveTow from "../pages/jurisdiction/indexactivetow";
import TerritoryActive from "../pages/jurisdiction/homeactive";
import InstitutionsActive from "../pages/jurisdiction/institutionsactive";
import InstitutionsActiveTow from "../pages/jurisdiction/institutionsactivetow";

//辖区管理 负责/管理
import Territorymanagement from "../pages/jurmanage/home";
import jurmanageIndex from "../pages/jurmanage/index";
import jurmanageIndexTow from "../pages/jurmanage/indexTow";
import jurmanage from "../pages/jurmanage/institutions";
import jurmanageTow from "../pages/jurmanage/institutionsTow";
import jurmanageChange from "../pages/jurmanage/jurmanageChange";
import jurmanageApproval from "../pages/jurmanage/jurmanageApproval";

//客户管理
import Clients from "../pages/staff/home.vue";
import StaffIndex from "../pages/staff/index.vue";
import retail from "../pages/staff/retail.vue";
import staffMap from "../pages/staff/staffMap.vue";
import channel from "../pages/staff/channel.vue";

//客户档案
import Files from "../pages/files/home.vue";
import FilesIndex from "../pages/files/index.vue";
import lingshou from "../pages/files/lingshou.vue";
import fileMap from "../pages/files/fileMap.vue";
import qudao from "../pages/files/qudao.vue";
import customCollect from "../pages/customCollect/home.vue";
import customCollectInfo from "../pages/customCollect/components/customCollectInfo.vue";
import zhunru_customCollectInfo from "../pages/customCollect/components/zhunru_customCollectInfo.vue";
import luoshiCustomCollect from "../pages/customCollect/luoshi_home.vue";
import luoshiAddCustomCollect from "../pages/customCollect/luoshi_custom.vue";
import luoshiReportProgressCollect from "../pages/customCollect/luoshi_report_progress.vue";
import bojianReportProgressCollect from "../pages/customCollect/bojian_report_progress.vue";
import resultCustomCollectInfo from "../pages/customCollect/components/result_customCollectInfo.vue";

//目标客户
import Target from "../pages/target/home.vue";
import TargetIndex from "../pages/target/index.vue";
import shenpi from "../pages/target/shenpi.vue";
import shengxiao from "../pages/target/shengxiao.vue";

//客户变更审批

import Pending from "../pages/Approval/home.vue";
import lingshou1 from "../pages/Approval/lingshou.vue";
import qudao1 from "../pages/Approval/qudao.vue";

// 客户数据采集
import Collection from "../pages/collection/index";
import CollectionHome from "../pages/collection/home";
import TaskProfile from "../pages/collection/components/taskProfile";
import CollectField from "../pages/collection/components/collectField";
import TaskRule from "../pages/collection/components/TaskRule";
import TaskZhunru from "../pages/collection/components/TaskZhunru";
import TaskParamsSetting from "../pages/collection/components/taskParamsSetting";
import TaskPerform from "../pages/collection/components/taskPerform";
import CollectData from "../pages/collection/components/collectData";

// 首页
import Home from "../pages/home/home";

//日程安排
import Calendar from "../pages/calendar/index";
import CalendarTable from "../pages/calendar/components/calendar";
import WeekplanInfo from "../pages/calendar/components/weekplanInfo";

//计划小结
import planSummary from "../pages/calendar/components/planSummary";
import planSummaryInfo from "../pages/calendar/components/planSummaryInfo";
//代办事项
import Task from "../pages/task/index";
import TaskList from "../pages/task/components/taskList";
import MessageList from "../pages/task/components/messageList";

// 辖区事务

// 辖区事务
import medical from "../pages/calendar/components/medical";
import dropDetails from "../pages/calendar/components/dropDetails";
import WeekPlan from "../pages/calendar/components/weekplan";
import conference from "../pages/calendar/components/conference";
import meetInfo from "../pages/calendar/components/meetInfo";
import tutoring from "../pages/calendar/components/tutoring";
import vacation from "../pages/calendar/components/vacation";
import holiday from "../pages/calendar/components/holiday";
import firmJob from "../pages/calendar/components/firmJob";
import syndicate from "../pages/calendar/components/syndicate";
import cultivate from "../pages/calendar/components/cultivate";
import train from "../pages/calendar/components/train";
import evection from "../pages/calendar/components/evection";
import travel from "../pages/calendar/components/travel";
import assist from "../pages/calendar/components/assist";
import business from "../pages/calendar/components/business";
import businessDetails from "../pages/calendar/components/businessDetails";
import jurisdictionIn from "../pages/calendar/components/JurisdictionIn";
import jurisdictionInfo from "../pages/calendar/components/jurisdictionInfo";
import storeTour from "../pages/calendar/components/storeTour";
import storeTourInfo from "../pages/calendar/components/storeTourInfo";
import onlineMeeting from "../pages/calendar/components/onlineMeeting";
import onlineMeetingInfo from "../pages/calendar/components/onlineMeetingInfo";

//报表
import StateMent from "../pages/statement/index";
import OverView from "../pages/statement/components/overview/overview";
import Reception from "../pages/statement/components/reception/index";
import visitCover from "../pages/statement/components/visitCover/index";

import SalesStatistical from "../pages/statement/components/SalesStatistical";
import EventAnalysis from "../pages/statement/components/eventAnalysis";
import TutoringAnalysis from "../pages/statement/components/TutoringAnalysis";
import TutoringAnalysisReport from "../pages/statement/components/TutoringAnalysisReport";
import TutoringReport from "../pages/statement/components/TutoringReport";
import DataExport from "../pages/statement/components/dataExport";
import SfeExport from "../pages/statement/components/SfeExport";
import LuoshiNimingExport from "../pages/statement/components/LuoshiNimingExport";

//产品管理
import Product from "../pages/product/productSku";
import ProductGroup from "../pages/product/productGroup";

//标准科室管理
import Standard from "../pages/standard/home";

//营销项目管理
import Project from "../pages/project/home";
//营销项目管理
import Speaker from "../pages/Speaker/home";

//销售数据
import SalesData from "../pages/salesdata/home";
import salesDataB2B from "../pages/salesdata/salesData";
import salesProductDetail from "../pages/salesdata/salesProductDetail";
import salesClientDetail from "../pages/salesdata/salesClientDetail";
import salesSkuYearDetail from "../pages/salesdata/salesSkuYearDetail";
import salesClientYearDetail from "../pages/salesdata/salesClientYearDetail";

import CSO_SalesData from "../pages/salesdata/cso_home";

//销售数据管理
import SalesDataManagement from "../pages/salesdataManagements/home";

//CSO销售数据管理
import cso_salesDataManagement from "../pages/salesdataManagements/cso_home";

//销售数据录入 Data entry
import DataEntry from "../pages/salesdataManagements/dataentry";

//绩效看板
import DashBoard from "../pages/dashboard/index";
//工作汇报
import WorkReport from "../pages/dashboard/components/workreport/workreport";
//客户覆盖
import CustomersCovered from "../pages/dashboard/components/customersCovered/customersCovered";
//销量达成
import SalesReached from "../pages/dashboard/components/salesReached/salesReached";
//辖区概述
import Summarize from "../pages/dashboard/components/summarize/summarize";
//协访分析
import Analyze from "../pages/dashboard/components/analyze/analyze";

//行政区检查
import RegionCheck from "../pages/RegionCheck/RegionCheck";

//国控订单
import orderInfo from "../pages/gkOrder/orderInfo";
//国控报表
import reportIndex from "../pages/gkReport/reportIndex";
import Inventory from "../pages/gkReport/Inventory";
import Activity from "../pages/gkReport/Activity";
import Personal from "../pages/gkReport/Personal";
import Prout from "../pages/gkReport/Prout";
import Visit from "../pages/gkReport/Visit";
import Sales from "../pages/gkReport/Sales";
import OrderQuery from "../pages/gkReport/OrderQuery";
import Salesman from "../pages/gkReport/Salesman";
import Logistics from "../pages/gkReport/Logistics";

// 学术管理

import EchoLibraryIndex from "../pages/echo/index";
import TagManage from "../pages/echo/Tag_manage";
import AlbumManage from "../pages/echo/album_manage";
import EchoCompliance from "../pages/echo/compliance";
import EchoComplianceDetail from "../pages/echo/compliance_detail";
import EchoLibraryBulk from "../pages/echo/library_bulk";
import EchoLibraryBulkDetail from "../pages/echo/library_bulk_detail";

//辖区概览
import PopedomOverview from '../pages/statement/components/PopedomOverview'
//签到看板
import SignKanBan from '../pages/statement/components/SignKanBan'
//半天事务看板
import DayAffairKanBan from '../pages/statement/components/DayAffairKanBan'
//机构拜访统计
import AgencyVisited from '../pages/statement/components/AgencyVisited'
//机构拜访统计
import LuoshiReportProgress from "../pages/statement/components/LuoshiReportProgress";
//机构拜访统计
import BojianReportProgress from "../pages/statement/components/BojianReportProgress";
//机构拜访统计
import CSO_SalesDataReport from "../pages/statement/components/CSO_SalesDataReport";

export var bus = new Vue();
Vue.use(Router);

let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/serviceWorkOrder",
      name: "ServiceWorkOrder",
      component: ServiceWorkOrder,
    },
    {
      path: "/serviceManage",
      name: "ServiceManage",
      component: ServiceManage,
    },
    {
      path: "/workOrderInfo",
      name: "WorkOrderInfo",
      component: WorkOrderInfo,
    },

    {
      path: "/library",
      name: "Library",
      component: Library,
      children: [
        {
          path: "index",
          component: DatabaseIndex,
        },
      ],
    },

    {
      path: "/target",
      name: "Target",
      component: Target,
      children: [
        {
          path: "index",
          component: TargetIndex,
        },
      ],
    },
    {
      path: "/pending",
      name: "Pending",
      component: Pending,
    },
    {
      path: "/pending/lingshou",
      name: "零售终端",
      component: lingshou1,
    },
    {
      path: "/pending/qudao",
      name: "分销客户",
      component: qudao1,
    },

    {
      path: "/clients",
      name: "Clients",
      component: Clients,
      children: [
        {
          path: "index",
          component: StaffIndex,
        },
      ],
    },
    {
      path: "/clients/retail",
      name: "零售终端",
      component: retail,
    },
    {
      path: "/clients/staffMap",
      name: "地图模式",
      component: staffMap,
    },

    {
      path: "/clients/channel",
      name: "分销客户",
      component: channel,
    },

    {
      path: "/files",
      name: "Files",
      component: Files,
      children: [
        {
          path: "index",
          component: FilesIndex,
        },
      ],
    },
    {
      path: "/files/lingshou",
      name: "零售终端",
      component: lingshou,
    },
    {
      path: "/files/fileMap",
      name: "零售终端",
      component: fileMap,
    },
    {
      path: "/files/qudao",
      name: "分销客户",
      component: qudao,
    },
    {
      path: "/target/shenpi",
      name: "待审批",
      component: shenpi,
    },
    {
      path: "/target/shengxiao",
      name: "待生效",
      component: shengxiao,
    },

    {
      path: "/stores",
      name: "Stores",
      component: Stores,
      children: [
        {
          path: "index",
          component: StoresIndex,
        },
        {
          path: "index",
          component: StoresInfoIndex,
        },
        {
          path: "indexSecond",
          component: StoresInfoIndexSecond,
        },
        {
          path: "area",
          component: Area,
        },
        {
          path: "areaSecond",
          component: AreaSecond,
        },
        {
          path: "city",
          component: City,
        },
        {
          path: "citySecond",
          component: CitySecond,
        },
      ],
    },
    {
      path: "/report",
      name: "Report",
      component: Report,
      children: [
        {
          path: "workingHours",
          component: WorkingHours,
        },
        {
          path: "shopStatistics",
          component: ShopStatistics,
        },
        {
          path: "salesStatistics",
          component: SalesStatistics,
        },
      ],
    },
    {
      path: "/attendance",
      name: "storeList",
      component: StoretList,
    },
    {
      path: "/attendance",
      component: Attendance,
      children: [
        {
          path: "editScheduling",
          component: EditScheduling,
        },
        {
          path: "historyScheduling",
          component: HistoryScheduling,
        },
        {
          path: "overtimeRecords",
          component: OvertimeRecords,
        },
        {
          path: "approveInfo",
          component: ApproveInfo,
        },
        {
          path: "shiftApply",
          component: ShiftApply,
        },
        {
          path: "shiftInfo",
          component: ShiftInfo,
        },
        {
          path: "vacationApply",
          component: VacationApply,
        },
        {
          path: "vacationInfo",
          component: VacationInfo,
        },
        {
          path: "retroactiveApply",
          component: RetroactiveApply,
        },
        {
          path: "retroactiveInfo",
          component: RetroactiveInfo,
        },
        {
          path: "attendanceStatistics",
          component: AttendanceStatistics,
        },
        {
          path: "hourStatistics",
          component: HourStatistics,
          // meta: {
          //     requireId: true
          // }
        },
        {
          path: "overtimeDetails",
          component: OvertimeDetails,
          // meta: {
          //     requireId: true
          // }
        },
      ],
    },
    {
      path: "/cruiseShop",
      name: "storeList",
      component: ShopStoretList,
    },
    {
      path: "/cruiseShop",
      component: CruiseShop,
      children: [
        {
          path: "basicInfo",
          component: ShopBasicInfo,
        },
        {
          path: "checkItems",
          component: ShopCheckItems,
          // meta: {
          //     requireId: true
          // }
        },
        {
          path: "assessment",
          component: ShopAssessment,
          // meta: {
          //     requireId: true
          // }
        },
      ],
    },
    {
      path: "/",
      redirect: { name: "Login" },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    //系统
    {
      path: "/system",
      name: "系统",
      component: System,
      redirect: "/system/roles",
      meta: {
        menuShow: true,
      },
      children: [
        {
          path: "region",
          component: Region,
        },

        {
          path: "dictionary",
          component: Dictionary,
        },
        {
          path: "custom",
          component: Custom,
        },
        {
          path: "roles",
          component: Roles,
        },
        {
          path: "taskManagement",
          component: TaskManagement,
        },
        {
          path: "companyNotice",
          name: "companyNotice",
          component: companyNotice,
        },
        {
          path: "messageAuthentication",
          name: "messageAuthentication",
          component: messageAuthentication,
        },

        {
          path: "dataHome",
          component: DataHome,
          children: [
            {
              path: "dataIndex",
              component: DataIndex,
            },
          ],
        },
        {
          path: "parameters",
          component: Parameters,
        },
        {
          path: "products",
          component: Products,
        },
        {
          path: "logtab",
          name: "logtab",
          component: logtab,
        },
        {
          path: "log_tab1",
          name: "log_tab1",
          component: log_tab1,
        },
        {
          path: "log_tab2",
          name: "log_tab2",
          component: log_tab2,
        },
      ],
    },
    {
      path: "/Territorymanagement",
      name: "Territorymanagement",
      component: Territorymanagement,
      redirect: "/Territorymanagement/index",
      children: [
        {
          path: "index",
          name: "JurisdictionIndex",
          component: jurmanageIndex,
        },
        {
          path: "institutions",
          name: "Institutions",
          component: jurmanage,
        },
        {
          path: "indexTow",
          name: "JurisdictionIndexTow",
          component: jurmanageIndexTow,
        },
        {
          path: "institutionsTow",
          name: "InstitutionsTow",
          component: jurmanageTow,
        },
      ],
    },
    {
      path: "/jurmanageChange",
      name: "jurmanageChange",
      component: jurmanageChange,
    },
    {
      path: "/jurmanageApproval",
      name: "jurmanageApproval",
      component: jurmanageApproval,
    },
    {
      path: "/territory",
      name: "Territory",
      component: Territory,
      redirect: "/territory/index",
      children: [
        {
          path: "index",
          name: "JurisdictionIndex",
          component: JurisdictionIndex,
        },
        {
          path: "institutions",
          name: "Institutions",
          component: Institutions,
        },
        {
          path: "indexTow",
          name: "JurisdictionIndexTow",
          component: JurisdictionIndexTow,
        },
        {
          path: "institutionsTow",
          name: "InstitutionsTow",
          component: InstitutionsTow,
        },
      ],
    },
    {
      path: "/territoryActive",
      name: "TerritoryActive",
      component: TerritoryActive,
      redirect: "/territoryActive/indexActive",
      children: [
        {
          path: "indexActive",
          name: "JurIndexActive",
          component: JurisdictionIndexActive,
        },
        {
          path: "insActive",
          name: "InsActive",
          component: InstitutionsActive,
        },
        {
          path: "indexActiveTow",
          name: "JurisdictionIndexTow",
          component: JurisdictionIndexActiveTow,
        },
        {
          path: "insActiveTow",
          name: "InstitutionsTow",
          component: InstitutionsActiveTow,
        },
      ],
    },
    {
      path: "/echoLibraryIndex",
      name: "EchoLibraryIndex",
      component: EchoLibraryIndex,
    },
    {
      path: "/albumManage",
      name: "AlbumManage",
      component: AlbumManage,
    },
    {
      path: "/tagManage",
      name: "TagManage",
      component: TagManage,
    },
    {
      path: "/echoCompliance",
      name: "echoCompliance",
      component: EchoCompliance,
    },
    {
      path: "/echoComplianceDetail",
      name: "echoComplianceDetail",
      component: EchoComplianceDetail,
    },
    {
      path: "/echoLibraryBulk",
      name: "echoLibraryBulk",
      component: EchoLibraryBulk,
    },
    {
      path: "/echoLibraryBulkDetail",
      name: "echoLibraryBulkDetail",
      component: EchoLibraryBulkDetail,
    },
    {
      path: "/Organization",
      name: "Organization",
      component: Organization,
    },
    {
      path: "/changzhou",
      name: "changzhou",
      component: changzhou,
      // redirect: "/changzhou/home",
    },
    {
      path: "/changzhou_set",
      name: "changzhou_set",
      component: changzhou_set,
      // redirect: "/changzhou/home",
    },
    //开发
    {
      path: "/systemDevelop",
      name: "Systemdevelop",
      component: Systemdevelop,
      redirect: "/systemDevelop/dictionaryDevelop",
      meta: {
        menuShow: true,
      },
      children: [
        {
          path: "regionDevelop",
          component: Regiondevelop,
        },

        {
          path: "dictionaryDevelop",
          component: Dictionarydevelop,
        },
        {
          path: "rolesDevelop",
          component: Rolesdevelop,
        },
        {
          path: "dataHomeDevelop",
          component: DataHomedevelop,
          children: [
            {
              path: "dataIndexDevelop",
              component: DataIndexdevelop,
            },
          ],
        },
        {
          path: "parametersDevelop",
          component: Parametersdevelop,
        },
        {
          path: "productsDevelop",
          component: Productsdevelop,
        },
        {
          path: "phonemenu",
          component: phonemenu,
        },
        {
          path: "pcmenu",
          component: pcmenu,
        },
        {
          path: "custom",
          component: customDevelop,
        },
        {
          path: "developTaskManage",
          component: developTaskManage,
        },
      ],
    },
    //服务
    {
      path: "/service",
      name: "Service",
      component: Service,
      children: [],
    },
    {
      path: "/collection",
      name: "collection",
      component: Collection,
      children: [
        {
          path: "taskProfile",
          name: "taskProfile",
          component: TaskProfile,
        },
        {
          path: "collectField",
          name: "collectField",
          component: CollectField,
        },
        {
          path: "taskRule",
          name: "taskRule",
          component: TaskRule,
        },
        {
          path: "taskZhunru",
          name: "taskZhunru",
          component: TaskZhunru,
        },
        {
          path: "taskParamsSetting",
          name: "taskParamsSetting",
          component: TaskParamsSetting,
        },
        {
          path: "taskPerform",
          name: "taskPerform",
          component: TaskPerform,
        },
        {
          path: "collectData",
          name: "collectData",
          component: CollectData,
        },
      ],
    },
    {
      path: "/collectionHome",
      name: "CollectionHome",
      component: CollectionHome,
      children: [],
    },
    {
      path: "/customCollectInfo",
      name: "customCollectInfo",
      component: customCollectInfo,
      children: [],
    },
    {
      path: "/zhunru_customCollectInfo",
      name: "zhunru_customCollectInfo",
      component: zhunru_customCollectInfo,
      children: [],
    },
    {
      path: "/resultCustomCollectInfo",
      name: "resultCustomCollectInfo",
      component: resultCustomCollectInfo,
      children: [],
    },
    {
      path: "/customCollect",
      name: "customCollect",
      component: customCollect,
      children: [],
    },
    {
      path: "/luoshiCustomCollect",
      name: "luoshiCustomCollect",
      component: luoshiCustomCollect,
      children: [],
    },
    {
      path: "/luoshiAddCustomCollect",
      name: "luoshiAddCustomCollect",
      component: luoshiAddCustomCollect,
      children: [],
    },
    {
      path: "/luoshiReportProgressCollect",
      name: "luoshiReportProgressCollect",
      component: luoshiReportProgressCollect,
      children: [],
    },
    {
      path: "/bojianReportProgressCollect",
      name: "bojianReportProgressCollect",
      component: bojianReportProgressCollect,
      children: [],
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      children: [],
    },

    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar,
      children: [
        {
          path: "calendarTable",
          name: "calendarTable",
          component: CalendarTable,
        },
        {
          path: "medical",
          name: "medical",
          component: medical,
        },
        {
          path: "dropDetails",
          name: "dropDetails",
          component: dropDetails,
        },
        {
          path: "planSummary",
          name: "planSummary",
          component: planSummary,
        },
        {
          path: "planSummaryInfo",
          name: "planSummaryInfo",
          component: planSummaryInfo,
        },
        {
          path: "weekPlan",
          name: "weekPlan",
          component: WeekPlan,
        },
        {
          path: "conference",
          name: "conference",
          component: conference,
        },
        {
          path: "meetInfo",
          name: "meetInfo",
          component: meetInfo,
        },
        {
          path: "weekPlanInfo",
          name: "WeekplanInfo",
          component: WeekplanInfo,
        },
        {
          path: "tutoring",
          name: "tutoring",
          component: tutoring,
        },
        {
          path: "assist",
          name: "assist",
          component: assist,
        },
        {
          path: "business",
          name: "business",
          component: business,
        },
        {
          path: "businessDetails",
          name: "businessDetails",
          component: businessDetails,
        },
        {
          path: "vacation",
          name: "vacation",
          component: vacation,
        },
        {
          path: "holiday",
          name: "holiday",
          component: holiday,
        },
        {
          path: "firmJob",
          name: "firmJob",
          component: firmJob,
        },
        {
          path: "syndicate",
          name: "syndicate",
          component: syndicate,
        },
        {
          path: "cultivate",
          name: "cultivate",
          component: cultivate,
        },
        {
          path: "train",
          name: "train",
          component: train,
        },
        {
          path: "evection",
          name: "evection",
          component: evection,
        },
        {
          path: "travel",
          name: "travel",
          component: travel,
        },
        {
          path: "jurisdictionIn",
          name: "jurisdictionIn",
          component: jurisdictionIn,
        },
        {
          path: "jurisdictionInfo",
          name: "jurisdictionInfo",
          component: jurisdictionInfo,
        },
        {
          path: "storeTour",
          name: "storeTour",
          component: storeTour,
        },
        {
          path: "storeTourInfo",
          name: "storeTourInfo",
          component: storeTourInfo,
        },
        {
          path: "onlineMeeting",
          name: "onlineMeeting",
          component: onlineMeeting,
        },
        {
          path: "onlineMeetingInfo",
          name: "onlineMeetingInfo",
          component: onlineMeetingInfo,
        },
      ],
    },
    {
      path: "/task",
      name: "task",
      component: Task,
      redirect: "/task/messageList",
      children: [
        {
          path: "taskList",
          name: "taskList",
          component: TaskList,
        },
        {
          path: "messageList",
          name: "messageList",
          component: MessageList,
        },
      ],
    },
    {
      path: "/product",
      name: "Product",
      component: Product,
    },
    {
      path: "/productgroup",
      name: "ProductGroup",
      component: ProductGroup,
    },
    {
      path: "/salesdata",
      name: "SalesData",
      component: SalesData,
    },
    {
      path: "/cso_salesdata",
      name: "CSO_SalesData",
      component: CSO_SalesData,
    },
    {
      path: "/salesDataB2B",
      name: "销售数据",
      component: salesDataB2B,
    },
    {
      path: "/salesProductDetail",
      name: "销售数据产品详情",
      component: salesProductDetail,
    },
    {
      path: "/salesClientDetail",
      name: "销售数据客户详情",
      component: salesClientDetail,
    },
    {
      path: "/salesSkuYearDetail",
      name: "销售数据SKU详情",
      component: salesSkuYearDetail,
    },
    {
      path: "/salesClientYearDetail",
      name: "销售数据SKU详情",
      component: salesClientYearDetail,
    },
    {
      path: "/salesManagement",
      name: "SalesDataManagement",
      component: SalesDataManagement,
    },
    {
      path: "/cso_salesManagement",
      name: "cso_salesDataManagement",
      component: cso_salesDataManagement,
    },
    {
      path: "/dashBoard",
      name: "DashBoard",
      component: DashBoard,
      redirect: "/dashBoard/workReport",
      children: [
        {
          path: "workReport",
          name: "WorkReport",
          component: WorkReport,
        },
        {
          path: "customersCovered",
          name: "CustomersCovered",
          component: CustomersCovered,
        },
        {
          path: "salesReached",
          name: "SalesReached",
          component: SalesReached,
        },
        {
          path: "summarize",
          name: "Summarize",
          component: Summarize,
        },
        {
          path: "analyze",
          name: "Analyze",
          component: Analyze,
        },
      ],
    },
    {
      path: "/dataentry",
      name: "DataEntry",
      component: DataEntry,
    },
    {
      path: "/statement",
      name: "StateMent",
      component: StateMent,
      children: [
        {
          path: "overview",
          name: "overview",
          component: OverView,
        },
        {
          path: "reception",
          name: "reception",
          component: Reception,
        },
        {
          path: "visitCover",
          name: "visitCover",
          component: visitCover,
        },
        {
          path: "SalesStatistical",
          name: "SalesStatistical",
          component: SalesStatistical,
        },
        {
          path: "EventAnalysis",
          name: "EventAnalysis",
          component: EventAnalysis,
        },
        {
          path: "TutoringAnalysis",
          name: "TutoringAnalysis",
          component: TutoringAnalysis,
        },
        {
          path: "TutoringAnalysisReport",
          name: "TutoringAnalysisReport",
          component: TutoringAnalysisReport,
        },
        {
          path: "TutoringReport",
          name: "TutoringReport",
          component: TutoringReport,
        },
        {
          path: "DataExport",
          name: "DataExport",
          component: DataExport,
        },
        {
          path: "SfeExport",
          name: "SfeExport",
          component: SfeExport,
        },
        {
          path: "LuoshiNimingExport",
          name: "LuoshiNimingExport",
          component: LuoshiNimingExport,
        },
        {
          path: "AgencyVisited",
          name: "AgencyVisited",
          component: AgencyVisited,
        },
        {
          path: "DayAffairKanBan",
          name: "DayAffairKanBan",
          component: DayAffairKanBan,
        },
        {
          path:'PopedomOverview',
          name:'PopedomOverview',
          component: PopedomOverview
        },
        {
          path:'SignKanBan',
          name:'SignKanBan',
          component: SignKanBan
        },
        {
          path:'LuoshiReportProgress',
          name:'LuoshiReportProgress',
          component: LuoshiReportProgress
        },
        {
          path:'BojianReportProgress',
          name:'BojianReportProgress',
          component: BojianReportProgress
        },
        {
          path:'CSO_SalesDataReport',
          name:'CSO_SalesDataReport',
          component: CSO_SalesDataReport
        },
      ],
    },
    {
      path: "/standard",
      name: "Standard",
      component: Standard,
    },
    {
      path: "/project",
      name: "Project",
      component: Project,
    },
    {
      path: "/speaker",
      name: "Speaker",
      component: Speaker,
    },
    {
      path: "/regionCheck",
      name: "RegionCheck",
      component: RegionCheck,
    },
    {
      path: "/orderInfo",
      name: "国控订单信息",
      component: orderInfo,
    },
    {
      path: "/reportIndex",
      name: "国控报表",
      component: reportIndex,
    },
    {
      path: "/Inventory",
      name: "Inventory",
      component: Inventory,
    },
    {
      path: "/Activity",
      name: "Activity",
      component: Activity,
    },
    {
      path: "/Personal",
      name: "Personal",
      component: Personal,
    },
    {
      path: "/Prout",
      name: "Prout",
      component: Prout,
    },
    {
      path: "/Visit",
      name: "Visit",
      component: Visit,
    },
    {
      path: "/Sales",
      name: "Sales",
      component: Sales,
    },
    {
      path: "/OrderQuery",
      name: "OrderQuery",
      component: OrderQuery,
    },
    {
      path: "/Salesman",
      name: "Salesman",
      component: Salesman,
    },
    {
      path: "/Logistics",
      name: "Logistics",
      component: Logistics,
    },
  ],
});
let clientsArr = ["/clients/index", "/clients/staffMap", "/clients/retail", "/clients/channel"];
router.beforeEach((to, from, next) => {
  document.title = localStorage.getItem("system_title") != null && localStorage.getItem("system_title") != "null" ? localStorage.getItem("system_title") : "";
  if (!clientsArr.includes(to.fullPath)) {
    router.app.$options.store.commit("resetMainCustomer");
  }

  let pathIndex = to.fullPath.split("?")[0];
  if (to.fullPath === "/login") {
    next();
  } else if (pathIndex === "/orderInfo") {
    // let s = (str.split("?")[1]).split("&")
    // let keyId =  s[0].split("=")[1]
    // let tenant_id = s[1].split("=")[1]
    // this.$store.commit('setQuery', {
    //      key_id: keyId,
    //      tenant_id:tenant_id,
    // })
    next();
  } else if (to.fullPath === "/reportIndex") {
    next();
  } else if (to.fullPath === "/Inventory") {
    next();
  } else if (to.fullPath === "/Activity") {
    next();
  } else if (to.fullPath === "/Personal") {
    next();
  } else if (to.path === "/Prout") {
    next();
  } else if (to.fullPath === "/Visit") {
    next();
  } else if (to.fullPath === "/Sales") {
    next();
  } else if (to.fullPath === "/OrderQuery") {
    next();
  } else if (to.fullPath === "/Salesman") {
    next();
  } else if (to.fullPath === "/Logistics") {
    next();
  } else {
    let user = getSession(userInfo);
    if (user && user.user_id) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js